// React
import React, { useState, useEffect } from 'react'

// Kendo
import { Fade } from "@progress/kendo-react-animation";

export default function Error(props) {
    const [ show, setShow ] = useState(false);
    const children =
        show
        ?
        (
            <div id="error">
                <span className="k-icon k-i-exception k-icon-xxxl" style={{ color: "white" }}></span>
                <div className="message">
                    { (props.enter && props.enter.message) && props.enter.message }
                </div>
            </div>
        )
        :
        null;

    useEffect(()=> {
        if (props.enter?.status === 'error') {
            setShow(true);
            setTimeout(() => {
                setShow(false);
                props.exit(null);
            }, 5000);
        }
    }, [ show, setShow, props ])

    return (
        <Fade transitionEnterDuration={ 300 } transitionExitDuration={ 300 }>
            { children }
        </Fade>
    )
};
